import styled from "@emotion/styled";

import { SvgInteractLogoText } from "@skilitics/designer-theme";

import { SIDEBAR_INLINE_PADDING } from "./sidebarStyles";

const Container = styled.div`
  flex: 0 0 auto;
  padding: 15px ${SIDEBAR_INLINE_PADDING}px;
`;

const Logo = styled(SvgInteractLogoText)`
  height: auto;
  width: 80%;
`;

export const SidebarLogo = () => (
  <Container>
    <Logo />
  </Container>
);
